import React, { Component } from 'react';

import classNames from 'classnames';
import { Badge } from 'components/badge';
import { I18n, translate } from 'components/translate';
import { observer } from 'mobx-react';
import Store from 'modules/userManager/userSearch/deepSearch/DeepSearchStore';
import PropTypes from 'prop-types';

import { menus } from './constants';

import './DeepSearchMenu.scss';

@translate()
@observer
export default class DeepSearchMenu extends Component {
  static propTypes = {
    updateSelectedMenu: PropTypes.func,
    menuSelected: PropTypes.object
  };

  render() {
    const { updateSelectedMenu, menuSelected } = this.props;

    const menuOptions = 'menu__text menu__text__options';
    const classContent = classNames(
      menuOptions,
      { menu__text__options__selected: menuSelected.content },
      { menu__text__options__not__selected: !menuSelected.content }
    );
    const classAccess = classNames(
      menuOptions,
      { menu__text__options__selected: menuSelected.access },
      { menu__text__options__not__selected: !menuSelected.access }
    );
    const classUser = classNames(
      menuOptions,
      { menu__text__options__selected: menuSelected.user },
      { menu__text__options__not__selected: !menuSelected.user }
    );
    const classActiveBadge = {
      content: menuSelected.content ? 'badge__selected' : '',
      access: menuSelected.access ? 'badge__selected' : '',
      user: menuSelected.user ? 'badge__selected' : ''
    };

    return (
      <div className="deep__search__menu">
        <div className="menu__text menu__text__title">
          <I18n label="users_manager.deep_search.lateral_menu.title" />
        </div>
        <div className="deep__search__menu__options">
          <div
            className={classContent}
            onClick={() => updateSelectedMenu(menus.content)}
          >
            <div className="badge__align">
              <I18n label="general.content" />
            </div>
            <div className="badge__align badge__space">
              <Badge
                value={Store.deepSearch.contentFilterCount}
                className={classActiveBadge.content}
              />
            </div>
          </div>
          <div
            className={classAccess}
            onClick={() => updateSelectedMenu(menus.access)}
          >
            <div className="badge__align">
              <I18n label="users_manager.deep_search.lateral_menu.access" />
            </div>
            <div className="badge__align badge__space">
              <Badge
                value={Store.deepSearch.accessFilterCount}
                className={classActiveBadge.access}
              />
            </div>
          </div>
          <div
            className={classUser}
            onClick={() => updateSelectedMenu(menus.user)}
          >
            <div className="badge__align">
              <I18n label="users_manager.deep_search.lateral_menu.user" />
            </div>
            <div className="badge__align badge__space">
              <Badge
                value={Store.deepSearch.userFilterCount}
                className={classActiveBadge.user}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
